import { ClassName } from '@boxcryptor-web/shared/class-name';
import React from 'react';
import { ExternalLink } from './ExternalLink';
import { useInternalLinkContext } from './InternalLinkContext';

export type InternalLink = {
  to: string;
  state?: { [x: string]: unknown };
  trackingId?: string;
};

export type InternalLinkProps = ClassName<InternalLink & { children: React.ReactNode }>;
export const InternalLink: React.FC<InternalLinkProps> = (props) => {
  const context = useInternalLinkContext();
  const replacedLink = context.getReplacedInternalLink(props.to);
  if (context.shouldRenderAsInternalLink(props.to)) {
    return <context.internalLinkComponent {...props} to={replacedLink} />;
  } else {
    return <ExternalLink {...props} href={replacedLink} target="_self" />;
  }
};
